import RootStore from '@App/stores/root-store'
import { action, observable, makeObservable } from 'mobx'
import { WorkModel } from '@Entities/work/work'
import * as workAPI from '@App/api/routes/work'
import Navigation from '@App/navigation'
import WorkStore from '@App/stores/work/work-store'

export default class PublicViewWorkStore {
    private rootStore: RootStore

    private _viewWorkPublic: WorkModel | undefined

    constructor(rootStore: RootStore) {
        makeObservable<PublicViewWorkStore, '_viewWorkPublic'>(this, {
            _viewWorkPublic: observable,
            setViewWorkPublic: action,
            resetViewWorkPublic: action,
        })

        this.rootStore = rootStore
    }

    get viewWorkPublic(): WorkModel | undefined {
        return this._viewWorkPublic
    }

    setViewWorkPublic(viewWorkPublic: WorkModel): void {
        this._viewWorkPublic = viewWorkPublic
    }

    resetViewWorkPublic(): void {
        this._viewWorkPublic = undefined
    }

    async getWorkCatalogById(id: string): Promise<void> {
        this.rootStore.preloaderStore.openMainPreloader(true)
        try {
            const response = await workAPI.getWorkCatalogById(id)
            if (!response) {
                return
            }
            const workWithLocalId: WorkModel = WorkStore.mapResponseToWorkObject(response.data)
            this.setViewWorkPublic(workWithLocalId)
        } catch (e) {
            this.rootStore.popupStore.setAlertFromError(e)
        } finally {
            if (!this.viewWorkPublic) {
                this.rootStore.popupStore.setAlertData('Could Not Find Work', true)
                this.rootStore.router?.navigate(Navigation.search.root())
            }
        }
        this.rootStore.preloaderStore.openMainPreloader(false)
    }
}
